import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import Home from '@/views/Home.vue'
import Subject from '@/views/examination/subject'
import Achievement from '@/views/achievement'
import ExamineeScore from '@/views/achievement/examineeScore.vue'
import LookPaper from '@/views/achievement/lookPaper.vue'
import ReviewPlan from '@/views/achievement/reviewPlan.vue'
import QuestionBank from '@/views/questionBank/questionBank'
import Question from '@/views/questionBank/question.vue'
import Verification from '@/views/questionBank/verification.vue'
import QuestionTag from '@/views/questionBank/questionTag'
import QuestionEdit from '@/views/questionBank/questionEdit'
import QuestionPreview from '@/views/questionBank/questionPreview'
import TestPaper from '@/views/questionBank/testPaper'
import TestPaperEdit from '@/views/questionBank/testPaperEdit'
import TestPaperPreview from '@/views/questionBank/testPaperPreview'
import ArrangeExam from '@/views/examination/arrangeExam'
import EditExam from '@/views/examination/arrangeExam/component/examEdit.vue'
import TrainingEnvironment from '@/views/trainingEnvironment'
import Marking from '@/views/marking'
import MarkingPaper from '@/views/marking/markingPaper.vue'
import ReviewPaper from '@/views/marking/reviewPaper.vue'
import ReviewDetails from "@/views/candidate/reviewDetails.vue";

import Candidate from '@/views/candidate'
import PracticalTraining from '@/views/candidate/practicalTraining'
import Iframe from '@/components/iframe'
import QuestionCopy from "@/views/questionBank/questionCopy.vue";
import {getUserInfo} from "@/api/common";

Vue.use(VueRouter)

const routes = [
    {path: "/userLogin", component: Login, name: "login"},
    {path: "/candidate", component: Candidate, name: "candidate"},
    {path: "/reviewDetails", component: ReviewDetails, name: "reviewDetails"},
    {path: "/practicalTraining", component: PracticalTraining, name: "practicalTraining"},
    {path: "/iframe", component: Iframe, name: "iframe"},
    // {path: "", redirect: "/subject"},
    // {path: "/", redirect: "/subject"},
    {path: '*', redirect: "/"},
    {
        path: '/',
        name: 'home',
        component: Home,
        children: [
            {
                path: 'subject',
                name: 'subject',
                component: Subject
            },
            {
                path: 'achievement',
                name: 'achievement',
                component: Achievement,
                meta: {
                    isBack: true,
                },
            },
            {
                path: 'examineeScore',
                name: 'examineeScore',
                component: ExamineeScore,
                meta: {
                    isBack: true,
                },
            },
            {
                path: 'lookPaper',
                name: 'lookPaper',
                component: LookPaper
            },
            {
                path: 'reviewPlan',
                name: 'reviewPlan',
                component: ReviewPlan
            },
            {
                path: 'questionBank',
                name: 'questionBank',
                component: QuestionBank,
                meta: {
                    isBack: true,
                },
            },
            {
                path: 'question',
                name: 'question',
                component: Question,
                meta: {
                    isBack: true,
                },
            },
            {
                path: 'questionEdit',
                name: 'questionEdit',
                component: QuestionEdit
            },
            {
                path: 'questionCopy',
                name: 'questionCopy',
                component: QuestionCopy
            },
            {
                path: 'questionPreview',
                name: 'questionPreview',
                component: QuestionPreview
            },
            {
                path: 'verification',
                name: 'verification',
                component: Verification
            },
            {
                path: 'questionTag',
                name: 'questionTag',
                component: QuestionTag
            },
            {
                path: 'testPaper',
                name: 'testPaper',
                component: TestPaper,
                meta: {
                    isBack: true,
                },
            },
            {
                path: 'testPaperEdit',
                name: 'testPaperEdit',
                component: TestPaperEdit
            },
            {
                path: 'testPaperPreview',
                name: 'testPaperPreview',
                component: TestPaperPreview
            },
            {
                path: 'arrangeExam',
                name: 'arrangeExam',
                component: ArrangeExam
            },
            {
                path: 'editExam',
                name: 'editExam',
                component: EditExam
            },
            {
                path: 'trainingEnvironment',
                name: 'trainingEnvironment',
                component: TrainingEnvironment
            },
            {
                path: 'marking',
                name: 'marking',
                component: Marking,
                // meta: {
                //     isBack: true,
                // },
            },
            {
                path: 'markingPaper',
                name: 'markingPaper',
                component: MarkingPaper,
                // meta: {
                //     isBack: true,
                // },
            },
            {
                path: 'reviewPaper',
                name: 'reviewPaper',
                component: ReviewPaper
            },
            {
                path: '/teacher',
                name: 'teacher',
                component: () => import('@/views/teacher/index.vue')
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    // base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    let token = localStorage.getItem("1+XUserIdentity");
    function goNext() {
        if (token === 'Candidate') {
            if (to.path == '/candidate' || to.path == '/practicalTraining' || to.path == '/reviewDetails') {
                next()
            }else {
                next({path: '/candidate'})
            }
        }else{
            if (to.path == '/candidate' || to.path == '/userLogin') {
                next({path: '/'})
            }else {
                next()
            }
        }
    }

    if (token && window.location.search !== '?login=fail') {
        let permissionCookie = localStorage.getItem('TOKEN_PERMISSION')
        if (!permissionCookie) {
            getUserInfo().then(res => {
                try {
                    localStorage.setItem("1+XAdministration", res.data.username);
                    localStorage.setItem('1+XPermissionsList', JSON.stringify(res.data.permissions))
                } catch (e) {
                    sessionStorage.clear()
                    localStorage.removeItem('1+XUserIdentity')
                    localStorage.removeItem('1+XPermissionsList')
                    next({path: '/logout'})
                }
            }).finally(() => {
                goNext()
            })
        } else {
            goNext()
        }
    } else {
        if (to.path == '/userLogin') {
            next()
        } else {
            next({path: '/userLogin' + window.location.search})
        }
    }
})

export default router
